module.exports = "/img/_/_/_/assets/images/creeper/battle/common//8.jpg?c58c59a2a4da1b75af886967b6894c96";